export default function matchStart(params, data) {
  // If there are no search terms, return all of the data
  if ($.trim(params.term) === '') {
    return data;
  }

  // Do not display the item if there is no 'text' property
  if (typeof data.text === 'undefined') {
    return null;
  }

  // Return data that starts with search term
  if (data.text.toUpperCase().indexOf(params.term.toUpperCase()) === 0) {
    return data;
  }

  return null;
}
